import React, { useEffect, useRef, useState } from 'react';
import SearchField from '../../../shared/components/SearchField';
import {
  PRICE_MAP_VALUE,
  PRICE_MAP_LABEL,
  CURRENCY_MAP_ICON,
} from '../constants/CurrencyClasses';

const formatNumber = (number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

const deformatNumber = (string) => {
  if (typeof string !== 'string') {
    string = String(string);
  }
  return parseInt(string.replace(/\s/g, ''), 10);
};

const PriceWidget = ({
  pricefrom,
  priceto,
  currency = 0,
  onChoose,
  cssClass = 'price',
}) => {
  const [open, setOpen] = useState(false);
  const [from, setFrom] = useState(pricefrom);
  const [to, setTo] = useState(priceto);
  const [currencyName, setCurrencyName] = useState(PRICE_MAP_LABEL[currency]);
  const [wasChanged, setWasChanged] = useState();
  const [title, setTitle] = useState('');

  const label = `Бюджет тура`;

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
      if (e.key === 'Escape') {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleClickOutside);
    };
  }, []);

  const handleSetFrom = (e) => {
    const { value } = e.target;
    let norm = deformatNumber(value);
    if (isNaN(norm)) {
      norm = 0;
    }
    setFrom(formatNumber(norm));
  };

  const handleSetTo = (e) => {
    const { value } = e.target;
    let norm = deformatNumber(value);
    if (isNaN(norm)) {
      norm = 0;
    }
    setTo(formatNumber(norm));
  };

  const setPrice = () => {
    let priceTo = to;
    let priceFrom = from;
    if (deformatNumber(to) < deformatNumber(from)) {
      setTo('');
      priceTo = '';
    }
    if (isNaN(deformatNumber(from)) || deformatNumber(from) === 0) {
      setFrom('');
      priceFrom = '';
    }
    onChoose({
      pricefrom: priceFrom.replace(/ /g, ''),
      priceto: priceTo.replace(/ /g, ''),
      currency: PRICE_MAP_VALUE[currencyName],
    });
    setOpen(false);
    setWasChanged(true);
  };

  useEffect(() => {
    if (deformatNumber(pricefrom) && deformatNumber(priceto) > 0) {
      setTitle(
        `${formatNumber(pricefrom)} - ${formatNumber(priceto)} ${
          CURRENCY_MAP_ICON[currencyName]
        }`
      );
    } else if (deformatNumber(pricefrom) > 0) {
      setTitle(
        `от ${formatNumber(pricefrom)} ${CURRENCY_MAP_ICON[currencyName]}`
      );
    } else if (deformatNumber(priceto) > 0) {
      setTitle(
        `до ${formatNumber(priceto)} ${CURRENCY_MAP_ICON[currencyName]}`
      );
    } else {
      setTitle(`Без ограничений ${CURRENCY_MAP_ICON[currencyName]}`);
    }
  }, [pricefrom, priceto, currencyName]);

  const handleCurrencyName = (event) => {
    if (event.target.title === currencyName) {
      return;
    }
    onChoose({
      pricefrom: from.replace(/ /g, ''),
      priceto: to.replace(/ /g, ''),
      currency: PRICE_MAP_VALUE[currencyName],
    });
    setCurrencyName(event.target.title);
  };

  function handlePopupOpen() {
    setOpen(!open);
  }

  return (
    <div ref={dropdownRef} className="search-widget price">
      <div
        onClick={handlePopupOpen}
        className={`search-field clickable ${wasChanged}`}
      >
        <SearchField
          cssClass={cssClass}
          placeholder={true}
          label={label}
          title={title}
          value={title}
        />
      </div>
      {open ? (
        <div className="popup-list">
          <div className="popup-body fixed">
            <div className="filterbar price">
              <div className="price__container-title">Бюджет</div>
              <button className="btn btn_submit" onClick={setPrice}>
                Готово
              </button>
            </div>
            <div className="price__container">
              <label className="price__input-label" htmlFor="pricefrom">
                От
              </label>
              <input
                type="text"
                name="pricefrom"
                id="pricefrom"
                autoFocus
                value={from}
                onChange={handleSetFrom}
              />
            </div>
            <div className="price__container">
              <label className="price__input-label" htmlFor="pricefrom">
                До
              </label>
              <input
                type="text"
                name="priceto"
                id="priceto"
                value={to}
                onChange={handleSetTo}
              />
            </div>
            <div className="currency-list">
              <div
                className={`${currencyName === 'RUB' ? 'active' : ''}`}
                title="RUB"
                onClick={(e) => handleCurrencyName(e)}
              >
                {CURRENCY_MAP_ICON['RUB']}
              </div>
              <div
                className={`${currencyName === 'USD' ? 'active' : ''}`}
                title="USD"
                onClick={(e) => handleCurrencyName(e)}
              >
                {CURRENCY_MAP_ICON['USD']}
              </div>
              <div
                className={`${currencyName === 'EUR' ? 'active' : ''}`}
                title="EUR"
                onClick={(e) => handleCurrencyName(e)}
              >
                {CURRENCY_MAP_ICON['EUR']}
              </div>
              <div
                className={`${
                  currencyName === 'KZT' || currencyName === 'TNG'
                    ? 'active'
                    : ''
                }`}
                onClick={(e) => handleCurrencyName(e)}
                title="KZT"
              >
                {CURRENCY_MAP_ICON['KZT']}
              </div>
              <div
                className={`${currencyName === 'BYR' ? 'active' : ''}`}
                title="BYR"
                onClick={(e) => handleCurrencyName(e)}
              >
                {CURRENCY_MAP_ICON['BYR']}
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default PriceWidget;
